import { Injectable } from '@angular/core';
import { BaseBackend } from '@shared/apis/servers/base-backend';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class Sc4uBackendServer extends BaseBackend {

  getHrmErrors(serialNo, sc4uObjectId): Observable<any> {
    return this.get(`/sc4u/${ serialNo }/hrm`, { params: { sc4uObjectId } });
  }

  dialogEngineStart(params): Observable<any> {
    return this.post(`/sc4u/dialog-engine/dialog-start`, params);
  }

  dialogEngine(params): Observable<any> {
    return this.post(`/sc4u/dialog-engine/dialog`, params);
  }

  getInHomeRepairPrice(params): Observable<any> {
    return this.post(`/sc4u/model/pricing-ih`, params);
  }

  getCiPsRepairPrice(params): Observable<any> {
    return this.post(`/sc4u/model/pricing-ps`, params);
  }

}
